// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import zutil from 'zutil';
import {i_extra_limit, t_generated_proxy, t_order, t_orders, t_zone_group}
    from '../../../../hola/pub/ui/pro/cp/orders';
import date from '/util/date.js';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {t_free_zone_params} from '../../lib/use_dashboard_data';
import {useCallback, useEffect, useMemo, useRef, useState} from 'react';
// @ts-ignore
import {set_json, get_json} from '/util/storage.js';
import {is_debug_ui} from '../../../../hola/pub/lib/debug';
import hola_opt from 'hola_opt';
import {i_plan_config} from '../../../../hola/pub/plus/plus_types';
import {i_user_info} from 'hola_app_context';
import {assert_proxy_type} from '../../../../oculus/pub/lib/asserts';

export const DEFAULT_IPS_AMOUNT = 10000;

export const date_fmt =
    (x: string): string=>x && date?.strftime('%b %d, %Y', x);

const MB = 1000000;
const GB = MB*1000;
const to_fixed = (n:number)=>Math.round(n*100)/100;
export const format_byte = (v:number, type: 'MB'|'GB')=>
    `${to_fixed(v/(type=='MB'?MB:GB))} ${type}`;
export const convert_byte_to_gb = (v:number)=>v/GB;

export const get_usage_data = (order: t_order)=>{
    const {usage_info, prev_usage, extra_limits = [],
        plan_limit, additional_limit = 0} = order;
    const current_used = usage_info?.used ?? 0;
    const previous_used = Math.min(prev_usage?.limit??0, prev_usage?.used??0);
    const extra_limit = extra_limits.reduce((acc, val)=>acc+val.limit, 0) ?? 0;
    const total_limit = plan_limit + additional_limit + extra_limit;
    const used = current_used - previous_used;
    return {used, total_limit, extra_limit};
};

const is_warn_usage = (n: number)=>n>=90;

const get_extra_data = (extra_used: number, extra_limits: i_extra_limit[],
    data_type: 'MB'|'GB')=>
    {
    const data = extra_limits?.map(l=>{
        const size_label = format_byte(l.limit, data_type);
        if (extra_used < 0)
        {
            return {...l, percent_number: 0, size_label, is_warn_usage: false,
                percent: '0%', is_full_usage: false,
                used_label: format_byte(0, data_type),
                limit_label: format_byte(l.limit, data_type),
            };
        }
        const left = l.limit - extra_used;
        const current_used = left <=0 ? l.limit : extra_used;
        const used_percent = Math.floor(current_used * 100 / l.limit);
        extra_used -= l.limit;
        return {...l, size_label, percent_number: used_percent,
            percent: `${used_percent}%`,
            used_label: format_byte(current_used, data_type),
            limit_label: format_byte(l.limit, data_type),
            is_warn_usage: is_warn_usage(used_percent),
            is_full_usage: used_percent >= 100,
        };
    }).sort((a, b)=>Number(a.is_full_usage) - Number(b.is_full_usage));
    return data;
};

export const get_usage_info = (order: t_order)=>{
    const {total_limit, used, extra_limit} = get_usage_data(order);
    const limit = convert_byte_to_gb(total_limit);
    const show_mb = limit < 1;
    const data_type = show_mb ? 'MB' : 'GB';
    if (!extra_limit)
    {
        const percent_number = Math.round(used * 100 / total_limit);
        return {
            used_label: format_byte(used, data_type),
            limit_label: format_byte(total_limit, data_type),
            percent: `${percent_number}%`,
            percent_number,
            is_warn_usage: is_warn_usage(percent_number),
        };
    }
    const base_limit = total_limit - extra_limit;
    const extra_used = used - base_limit;
    const percent_number = extra_used > 0 ? 100
        : Math.floor(used * 100 / base_limit);
    const extra = get_extra_data(extra_used, order.extra_limits, data_type);
    return {
        used_label: format_byte(used > base_limit
            ? base_limit : used, data_type),
        limit_label: format_byte(base_limit, data_type),
        percent: `${percent_number}%`,
        percent_number,
        is_full_usage: percent_number >= 100,
        extra,
    };
};

export const get_group_usage_info = (group: t_zone_group)=>{
    if (!group.zones?.length)
    {
        return {
            used_label: `0 GB`,
            limit_label: `${group.limit} GB`,
            percent: `0%`,
            percent_number: 0,
            is_full_usage: false,
        };
    }
    const data = group.zones.reduce((acc, o)=>{
        acc.current_used += (o.usage_info?.used ?? 0)
            - (o.prev_usage?.used ?? 0);
        acc.plan_limit += o.plan_limit;
        return acc;
    }, {total_limit: group.limit, current_used: 0, previous_used: 0,
        plan_limit: 0});
    const percent_number = Math.round(
        (data.current_used - data.previous_used) * 100 / data.total_limit
    );
    const limit = convert_byte_to_gb(data.total_limit);
    const show_mb = limit<1;
    const data_type = show_mb?'MB':'GB';
    const extra_used = data.current_used - data.plan_limit;
    const extra = get_extra_data(extra_used, group.extra_limits, data_type);
    return {
        used_label: format_byte(data.current_used - data.previous_used,
            data_type),
        limit_label: format_byte(data.total_limit, data_type),
        percent: `${percent_number}%`,
        percent_number,
        is_warn_usage: is_warn_usage(percent_number),
        extra,
    };
};

export const download_csv = (type: string,
    proxies?: t_generated_proxy[], omit_credentials = false)=>
{
    if (!proxies?.length)
        return;
    try {
        (window as any).dataLayer.push({
            event: 'gtag.download_proxy',
        });
    } catch(e){}
    const csv_fn = `${type}-${date.strftime('%d-%b-%y', new Date())}.csv`;
    const content = proxies_to_csv(
        proxies.filter(p=>p.manually_changed), omit_credentials);
    do_download_file(csv_fn, content);
};

export const download_json = (type: string,
    proxies?: t_generated_proxy[], omit_credentials = false)=>
{
    if (!proxies?.length)
        return;
    try {
        (window as any).dataLayer.push({
            event: 'gtag.download_proxy',
        });
    } catch(e){}
    const csv_fn = `${type}-${date.strftime('%d-%b-%y', new Date())}.json`;
    const content = proxies_to_json(
        proxies.filter(p=>p.manually_changed), omit_credentials);
    do_download_file(csv_fn, content);
};

export const download_generic = (type: string,
    proxies?: t_generated_proxy[], omit_credentials=false)=>
    {
    if (!proxies?.length)
        return;
    try {
        (window as any).dataLayer.push({
            event: 'gtag.download_proxy',
        });
    } catch(e){}
    const csv_fn = `${type}-${date.strftime('%d-%b-%y', new Date())}.txt`;
    const content = proxies_to_generic(
        proxies.filter(p=>p.manually_changed), omit_credentials);
    do_download_file(csv_fn, content);
};

export const download_insomniac = (type: string,
    proxies?: t_generated_proxy[], omit_credentials=false)=>
    {
    if (!proxies?.length)
        return;
    try {
        (window as any).dataLayer.push({
            event: 'gtag.download_proxy',
        });
    } catch(e){}
    const csv_fn = `${type}-insomniac-`+
        `${date.strftime('%d-%b-%y', new Date())}.txt`;
    const content = proxies_to_insomniac(
        proxies.filter(p=>p.manually_changed), omit_credentials);
    do_download_file(csv_fn, content);
};

export type t_download_format = 'json' | 'csv' | 'generic' | 'insomniac';
export const download_format = (format: t_download_format, type: string,
    proxies?: t_generated_proxy[], omit_credentials=false)=>
    {
    switch (format)
    {
    case 'json':
        return void download_json(type, proxies, omit_credentials);
    case 'generic':
        return void download_generic(type, proxies, omit_credentials);
    case 'insomniac':
        return void download_insomniac(type, proxies, omit_credentials);
    default:
        download_csv(type, proxies, omit_credentials);
    }
};

const proxies_to_csv = (proxies: t_generated_proxy[],
    omit_credentials=false)=>
{
    const header = omit_credentials
        ? 'host,port,ip,country,socks5'
        : 'login,password,host,port,ip,country,socks5';
    const proxy_to_line = (p:t_generated_proxy)=>
        [
            ...omit_credentials ? [] : [p.login, p.password],
            p.host, p.port, p.ip, p.country, p.socks5
        ].join(',');
    return [header, ...proxies.map(proxy_to_line)].join('\n');
};

const proxies_to_generic = (proxies: t_generated_proxy[],
    omit_credentials=false)=>
{
    const proxy_to_line = (p:t_generated_proxy)=>{
        return [
            p.ip || p.host, p.port,
            ...omit_credentials ? []: [p.login, p.password]
        ].join(':');
    };
    return proxies.map(proxy_to_line).join('\n');
};

const proxies_to_insomniac = (proxies: t_generated_proxy[],
    omit_credentials=false)=>
{
    const proxy_to_line = (p:t_generated_proxy)=>[
        '', p.ip || p.host, p.port,
        ...omit_credentials ? [] : [p.login, p.password]
    ].join(',');
    return proxies.map(proxy_to_line).join('\n');
};

const proxies_to_json = (proxies: t_generated_proxy[],
    omit_credentials=false)=>
{
    const fields = [
        ...omit_credentials ? [] : ['login', 'password'],
        'host', 'port', 'ip', 'country', 'socks5'
    ];
    return JSON.stringify(proxies.map(p=>zutil.pick(p, fields)), null, 2);
};

const do_download_file = (fn: string, content: string)=>{
    const blob = new Blob([content], {type: 'text/csv'});
    const el = document.createElement('a');
    el.href = URL.createObjectURL(blob);
    el.download = fn;
    el.click();
    URL.revokeObjectURL(el.href);
};

export const is_order_expired = (item: t_order)=>{
    const order_date_until = date(item.renew_error && !item.cancelled_manually
        ? item.blocking_date : item.subscription_until);
    return item.next_zone_id || order_date_until < date();
};

export const is_group_expired = (item: t_zone_group)=>{
    return item.next_group_id || date(item.until) < date();
};

export const total_orders_count = (orders:t_orders)=>{
    if (!orders)
        return 0;
    let total = 0;
    Object.values(orders).forEach(v=>total+=v.length);
    return total;
};

export const has_free_plan = (orders:t_orders)=>{
    if (!orders)
        return false;
    for (const oo of Object.values(orders))
    {
        if (oo.some(o=>o.free_zone))
            return true;
    }
    return false;
};

export const has_active_plan = (orders:t_orders)=>{
    if (!orders)
        return false;
    return Object.values(orders)
        .some(by_type=>by_type.some(item=>!is_order_expired(item)));
};

export const get_active_group = (groups: t_zone_group[])=>{
    return groups?.find(g=>!is_group_expired(g)) ?? null;
};

export const show_free_plan_promo = (orders:t_orders,
    free_zone_params: t_free_zone_params)=>
{
    const empty_orders = total_orders_count(orders) == 0;
    return empty_orders && !free_zone_params;
};

const empty_proxy = {host: 'proxy.toolip.io', port: '331***', ip: '',
    manually_changed: true, login: '8c5906b99fbd1c0***',
    password: 'iuz5k7bp***', socks5: false};

export const get_free_zone = (params?: t_free_zone_params)=>{
    if (!params)
        return null;
    const proxies = [{country: params.country??'us', ...empty_proxy}];
    const free_zone_fake: t_order = {
        _id: 'free_fake',
        zone: params.type,
        client_id: 'free',
        free_zone: true,
        start: new Date().toISOString(),
        until: new Date(new Date().setDate(new Date().getDate() + 2))
            .toISOString(),
        limit: 100000000,
        plan_limit: 100000000,
        generated_proxies: proxies,
        ips_amount: 1,
        type: params.type,
        usage_info: {used: 0},
        unit: params.type == 'smart_resi' ? 'gb' : 'ip',
    };
    return free_zone_fake;
};

export const get_orders_fake = ()=>{
    const orders = {
        [Proxy_type.ISP]: [],
        [Proxy_type.ISPPREM]: [],
        [Proxy_type.DDC]: [],
        [Proxy_type.SDC]: [],
        [Proxy_type.RES]: [],
    };
    const free_zone = get_free_zone();
    if (!free_zone)
        return orders;
    orders[free_zone.type] = [free_zone];
};

export const new_order_ids = (orders:t_orders)=>{
    if (!orders)
        return [];
    let ids = [];
    Object.values(orders).forEach(v=>ids = ids.concat(
        v.filter(o=>o.user_state?.is_new).map(o=>o._id)));
    return ids;
};

interface i_orders_stats {
    active_plans: number;
    generated_amount: number;
    countries_accessed: number;
}

export const get_orders_stats = (orders: t_orders)=>{
    if (!orders)
        return {} as i_orders_stats;
    const stats: i_orders_stats = {
        active_plans: 0,
        generated_amount: 0,
        countries_accessed: 0,
    };
    Object.keys(orders).forEach(type=>{
        const _orders = orders[type] as t_order[];
        const _countries = [];
        _orders.forEach(item=>{
            if (!is_order_expired(item))
                stats.active_plans += 1;
            const generated = item.generated_proxies
                .filter(p=>p.manually_changed);
            stats.generated_amount += generated.length;
            _countries.push(...generated.map(p=>p.country));
        });
        stats.countries_accessed = new Set(_countries).size;
    });
    return stats;
};

export const align_table_sizes = tables=>{
    if (!tables.length)
        return;
    const run_for_all_cells = (cols, fn)=>{
        tables.forEach(table=>{
            for (let n = 0; n < table.rows.length; n++)
            {
                const row = table.rows[n];
                for (let i = 0; i < cols; i++)
                {
                    const cell = row.cells[i];
                    fn(cell, i);
                }
            }
        });
    };
    const cols_count = tables[0].rows[0].cells.length;
    const cols_widths = new Array(cols_count).fill(0);
    run_for_all_cells(cols_count, cell=>{
        cell.style.minWidth = ``;
    });
    run_for_all_cells(cols_count, (cell, i)=>{
        cols_widths[i] = Math.max(cols_widths[i], cell.offsetWidth);
    });
    run_for_all_cells(cols_count, (cell, i)=>{
        cell.style.minWidth = `${cols_widths[i]}px`;
    });
};

const get_smart_resi_proxies = (order: t_order)=>{
    const free_fake_regex = /^[a-z0-9]+(\*{3})$/;
    const plan_login_regex = /-country-\w\w-session-.+/;
    const correct_proxy = (order?.generated_proxies||[]).find(p=>{
        return plan_login_regex.test(p.login) || free_fake_regex.test(p.login);
    });
    if (!correct_proxy)
        return [];
    return [correct_proxy];
};

export const get_generated_proxies = (order: t_order)=>{
    if (!order)
        return [];
    return [Proxy_type.RES, Proxy_type.EV_RES, Proxy_type.SNK]
        .includes(order.type) ? get_smart_resi_proxies(order)
        : order.generated_proxies ?? [];
};

export const get_visible_actions = (order: t_order)=>{
    if (!order || order.type == Proxy_type.UNKNOWN)
        return {update_payment: false, buy_new: false};
    // xxx maksimd: handle renew error for toolip
    if (order.renew_error && !order.cancelled_manually)
        return {update_payment: true};
    if (order.expired_recently)
        return {buy_new: true};
    const is_resi = ['smart_resi', 'events_resi_tickets'].includes(order.type);
    const ips_amount = is_resi
        ? DEFAULT_IPS_AMOUNT : order.ips_amount;
    const generated = get_generated_proxies(order);
    let generate = order.type == 'isp_plus' ? false
        : is_type_with_manual_proxies(order.type)
        ? generated.filter(p=>p.manually_changed).length < ips_amount
        : is_resi && generated.length>0
        ? false : ips_amount > generated.length;
    if (is_debug_ui('generic_proxies') && order.unit=='gb' && generated.length)
        generate = true;
    let config_list = is_type_with_manual_proxies(order.type)
        ? generated.some(p=>p.manually_changed)
        : generated.length>0;
    return {config_list, generate};
};

export const is_type_with_manual_proxies = (type: Proxy_type)=>{
    return [Proxy_type.DDC, Proxy_type.ISP, Proxy_type.SDC].includes(type);
};

export const ORDER_TYPE_NAMES: Record<Proxy_type, string> = {
    [Proxy_type.SDC]: 'Shared Datacenter Proxies',
    [Proxy_type.DDC]: 'Dedicated Datacenter Proxies',
    [Proxy_type.SHARED_ISP]: 'ISP Proxies',
    [Proxy_type.ISP]: 'Global ISP Proxies',
    [Proxy_type.ISPPREM]: 'Search Engine ISP Proxies',
    [Proxy_type.RES]: 'Rotating Residential Proxies',
    [Proxy_type.EV_ISP]: 'Events & E-commerce Residential Proxies',
    [Proxy_type.EV_RES]: 'Events Tickets Residential Proxies',
    [Proxy_type.SNK]: 'Sneakers Residential Proxies',
    [Proxy_type.SCR]: 'Scraping Browser',
    [Proxy_type.UNKNOWN]: 'Proxies'
};

export const use_disappear = (seconds: number)=>{
    const timer = useRef<ReturnType<typeof setTimeout>>();
    const [visible, set_visible] = useState(false);
    const show = ()=>{
        set_visible(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(()=>set_visible(false), seconds*1000);
    };
    return {visible, show};
};

export const use_interval = (cb: ()=>void, delay_sec: number)=>{
    const saved_callback = useRef<typeof cb>();
    useEffect(()=>{
        saved_callback.current = cb;
    }, [cb]);
    useEffect(()=>{
        if (!delay_sec)
            return;
        const tick = ()=>saved_callback.current();
        const id = setInterval(tick, delay_sec*date.ms.SEC);
        return ()=>clearInterval(id);
    }, [delay_sec]);
};

interface i_find_order_by_params {
    orders?: t_orders;
    zone_groups?: t_zone_group[];
    find_fn: (o:t_order)=>boolean;
}
export const find_order_by = (params: i_find_order_by_params)=>{
    const {orders, zone_groups, find_fn} = params;
    if (!orders && !zone_groups)
        return null;
    for (let orders_by_type of Object.values(orders ?? {}))
    {
        const order = orders_by_type.find(find_fn);
        if (order)
            return order;
    }
    for (let group of zone_groups ?? [])
    {
        const order = group.zones.find(find_fn);
        if (order)
            return order;
    }
    return null;
};

export const order_by_id = (orders: t_orders, id: string)=>{
    return find_order_by({orders, find_fn: o=>o._id == id});
};

export const group_order_by_id = (groups: t_zone_group[], o_id: string)=>{
    return find_order_by({zone_groups: groups, find_fn: o=>o._id == o_id});
};

export const find_order_by_id =
(id: string, orders: t_orders, zone_groups: t_zone_group[])=>{
    return find_order_by({orders, zone_groups, find_fn: o=>o._id == id});
};

interface i_configured_proxies_create_params {
    country: string;
    count: number;
    order: t_order;
    socks5: boolean;
}
export const configured_proxies_create =
  (params: i_configured_proxies_create_params)=>
    set_json(`configured_proxies_${params.order._id}`,
        generate_proxies(params));

export const configured_proxies_get = (id: string)=>
    get_json(`configured_proxies_${id}`) as t_generated_proxy[];

const socks5_port = 31115;

const generate_proxies = (params: i_configured_proxies_create_params)=>{
    if (!params.order.generated_proxies?.length)
        return [];
    const {host, port, login, password} = params.order.generated_proxies[0];
    const login_with_country = login.replace(/-country-[a-z]{2}-/i,
        `-country-${params.country.toUpperCase()}-`);
    const proxies = Array.from({length: params.count}).map(()=>({
        login: login_with_country
          .replace(/-session-[a-f0-9]+$/, `-session-${generate_hex_id()}`),
        port: params.socks5 ? socks5_port : port,
        host, password, manually_changed: true}));
    return proxies;
};

const generate_hex_id = ()=>Math.floor(Math.random() * 0xfffff)
    .toString(16).padEnd(5, '0');

export interface i_sorting_state {
    is_sorted: boolean;
    sorted_field: keyof t_order | null;
    is_asc: boolean;
}

export const use_active_orders =
(orders: t_order[], show_recently_expired?: boolean)=>{
    const active = useMemo<t_order[]>(
        ()=>orders.filter(order=>!is_order_expired(order)
            || show_recently_expired && order.expired_recently),
        [orders, show_recently_expired]);
    return active;
};

export const use_expired_orders =
(orders: t_order[], hide_recently_expired?: boolean)=>{
    const active = useMemo<t_order[]>(
        ()=>orders.filter(order=>is_order_expired(order)
            && !(hide_recently_expired && order.expired_recently)),
        [orders, hide_recently_expired]);
    return active;
};

export const use_sorting = (enable_sorting: boolean, orders: t_order[])=>{
    const [sorting_state, set_sorting_state] = useState<i_sorting_state>({
      is_sorted: false,
      sorted_field: null,
      is_asc: true
    });
    const set_sorting = useCallback((field: keyof t_order)=>{
        if (!enable_sorting)
            return;
        set_sorting_state(s=>{
          if (s.sorted_field==field)
              return {...s, is_sorted: true, is_asc: !s.is_asc};
          return {is_sorted: true, sorted_field: field, is_asc: false};
        });
    }, []);
    const sorted_orders = useMemo<t_order[]>(()=>{
        if (!sorting_state.is_sorted)
            return orders;
        return orders.sort((a, b)=>{
          let a_value: any, b_value: any;
          switch (sorting_state.sorted_field)
          {
              case 'start':
                  a_value = new Date(a.start);
                  b_value = new Date(b.start);
                  break;
              case 'until':
                  a_value = new Date(a.until);
                  b_value = new Date(b.until);
                  break;
              case 'ips_amount':
                  a_value = a.ips_amount ?? 0;
                  b_value = b.ips_amount ?? 0;
                  break;
              case 'usage_info':
                  a_value = a.usage_info?.used ?? 0;
                  b_value = b.usage_info?.used ?? 0;
                  break;
              case 'generated_proxies':
                  a_value = a.generated_proxies?.filter(
                    p=>!['isp', 'dedicated_dc'].includes(a.type) ||
                    p.manually_changed).length ?? 0;
                  b_value = b.generated_proxies?.filter(
                      p=>!['isp', 'dedicated_dc'].includes(a.type) ||
                      p.manually_changed).length ?? 0;
                  break;
          }
          return sorting_state.is_asc ? a_value - b_value : b_value - a_value;
      });
    }, [orders, sorting_state]);
    return {sorting_state, set_sorting, sorted_orders};
};

export const order_has_renew_error = (order: t_order)=>
    !is_order_expired(order) && order.renew_error?.length > 0;

export const get_renew_error_orders = (orders:t_orders)=>{
    if (!orders)
        return [];
    return Object.values(orders).reduce((acc, oo)=>{
        const error_orders = oo.filter(order_has_renew_error);
        if (error_orders.length)
            acc.push(...error_orders);
        return acc;
    }, []);
};

export const get_payment_renew_url = (order: t_order)=>{
    const {type, ips_amount, plan_duration, plan_limit, unit, plan_id} = order;
    const url_by_plan_id = (id: string)=>
        `/pricing/checkout?plan_id=${id}&zone_id=${order._id}&renew_payment=1`;
    if (plan_id)
        return url_by_plan_id(plan_id);
    const no_matched_plan = `/dashboard/page/plans`
        +`?notification=no_matched_plans&type=${order.type}`;
    const {all_plans, plans_config} = hola_opt;
    const plans_by_type = all_plans.filter(p=>p.type == type)
        .map(p=>({id: p.id, ...plans_config[p.id]}));
    if (!plans_by_type.length)
        return no_matched_plan;
    const plans_by_unit = unit == 'ip'
        ? plans_by_type.filter(p=>p.ips_amount==ips_amount)
        : plans_by_type.filter(p=>p.limit==convert_byte_to_gb(plan_limit));
    if (!plans_by_unit.length)
        return no_matched_plan;
    const plan_dur = plan_duration || get_plan_duration(order);
    const fallback_duration = '1m';
    const plan = plans_by_unit.find(p=>is_same_period(plan_dur, p.period))
        ?? plans_by_unit.find(p=>is_same_period(fallback_duration, p.period));
    if (!plan)
        return no_matched_plan;
    return url_by_plan_id(plan.id);
};

const get_plan_duration = (order: t_order)=>{
    const diff = date(order.subscription_until) - date(order.start);
    const plan_duration_days = Math.round(diff/date.ms.DAY);
    if (Math.abs(plan_duration_days - 7) <= 1)
        return '1w';
    else if (Math.abs(plan_duration_days - 30) <= 3)
        return '1m';
    else if (Math.abs(plan_duration_days - 90) <= 5)
        return '3m';
    return '1m';
};

type t_plan_period = i_plan_config['period'];
const period_mappings: Record<t_plan_period, string[]> = {
    '1d': ['1d', '1day'],
    '1w': ['1w', '1week'],
    '1m': ['1m', '1month'],
    '3m': ['3m', '3month'],
    '1y': ['1y', '1year'],
};
const is_same_period = (dur: string, period: t_plan_period)=>
    period_mappings[period]?.includes(dur);

export const get_email = (user: i_user_info)=>
    user?.emails ? user?.emails[0].value : null;

const sort_orders_desc = (orders: t_order[])=>
    orders.sort((a, b)=>date(b.start)-date(a.start));

type combined_zones = ({type: Proxy_type, orders: t_order[]} | t_zone_group)[];

export const combine_and_sort_zones =
(orders: t_orders, groups?: t_zone_group[]): combined_zones=>{
    const orders_grouped = Object.entries(orders || {})
        .filter(([, oo])=>oo.some(o=>!is_order_expired(o)))
        .map(([type, oo])=>{
            assert_proxy_type(type);
            const sorted = sort_orders_desc(oo);
            return {type, orders: sorted};
        });
    const combined_orders = [
        ...orders_grouped,
        ...groups?.filter(g=>!is_group_expired(g)) ?? []
    ];
    combined_orders.sort((a, b)=>{
        const a_date = date('start' in a ? a.start : a.orders[0].start);
        const b_date = date('start' in b ? b.start : b.orders[0].start);
        return b_date-a_date;
    });
    return combined_orders;
};

export const get_group_zones = (group?: t_zone_group)=>group?.zones ?? [];
